/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CognitoStatusDto
 */
export interface CognitoStatusDto {
    /**
     * Cognito user status. NOT_FOUND means the user exists in our DB but not in the Cognito pool.
     * @type {object}
     * @memberof CognitoStatusDto
     */
    status: object;
    /**
     * Cognito account enabled flag
     * @type {boolean}
     * @memberof CognitoStatusDto
     */
    enabled?: boolean;
    /**
     * When the Cognito account was created
     * @type {Date}
     * @memberof CognitoStatusDto
     */
    userCreatedAt?: Date;
    /**
     * Last time the Cognito account was modified
     * @type {Date}
     * @memberof CognitoStatusDto
     */
    userLastModifiedAt?: Date;
    /**
     * Phone number Cognito holds for this user
     * @type {string}
     * @memberof CognitoStatusDto
     */
    phoneNumber?: string;
}

/**
 * Check if a given object implements the CognitoStatusDto interface.
 */
export function instanceOfCognitoStatusDto(value: object): value is CognitoStatusDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function CognitoStatusDtoFromJSON(json: any): CognitoStatusDto {
    return CognitoStatusDtoFromJSONTyped(json, false);
}

export function CognitoStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CognitoStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'userCreatedAt': json['userCreatedAt'] == null ? undefined : (new Date(json['userCreatedAt'])),
        'userLastModifiedAt': json['userLastModifiedAt'] == null ? undefined : (new Date(json['userLastModifiedAt'])),
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
    };
}

export function CognitoStatusDtoToJSON(value?: CognitoStatusDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'enabled': value['enabled'],
        'userCreatedAt': value['userCreatedAt'] == null ? undefined : ((value['userCreatedAt']).toISOString()),
        'userLastModifiedAt': value['userLastModifiedAt'] == null ? undefined : ((value['userLastModifiedAt']).toISOString()),
        'phoneNumber': value['phoneNumber'],
    };
}

